var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConditionIcon = function SvgConditionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.126 21.25h-4.001v-4.688a4.693 4.693 0 0 0-4.688-4.687h-3.125c-.863 0-1.562.7-1.562 1.563v7.812H1.562C.7 21.25 0 21.95 0 22.813v15.625C0 39.3.7 40 1.563 40H30.25a4.7 4.7 0 0 0 4.596-3.768l1.875-9.375a4.67 4.67 0 0 0-.971-3.891 4.67 4.67 0 0 0-3.625-1.716ZM3.125 24.375H12.5v12.5H3.125v-12.5Zm28.658 11.244 1.875-9.375a1.556 1.556 0 0 0-.324-1.297 1.557 1.557 0 0 0-1.208-.572h-5.563c-.863 0-1.563-.7-1.563-1.563v-6.25c0-.861-.7-1.562-1.563-1.562h-1.562v7.813c0 .863-.7 1.562-1.563 1.562h-4.687v12.5h14.626c.742 0 1.386-.528 1.532-1.256Z",
    fill: "#047992"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.688 6.25h1.562v1.563a1.562 1.562 0 1 0 3.125 0V6.25h1.563a1.562 1.562 0 1 0 0-3.125h-1.563V1.562a1.562 1.562 0 1 0-3.125 0v1.563h-1.563a1.562 1.562 0 1 0 0 3.125ZM7.188 6.25H8.75v1.563a1.562 1.562 0 1 0 3.125 0V6.25h1.563a1.562 1.562 0 1 0 0-3.125h-1.563V1.562a1.562 1.562 0 1 0-3.125 0v1.563H7.187a1.562 1.562 0 1 0 0 3.125ZM38.438 3.125h-1.563V1.562a1.562 1.562 0 1 0-3.125 0v1.563h-1.563a1.562 1.562 0 1 0 0 3.125h1.563v1.563a1.562 1.562 0 1 0 3.125 0V6.25h1.563a1.562 1.562 0 1 0 0-3.125Z",
    fill: "#047992"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.813,
    cy: 32.188,
    r: 1.563,
    fill: "#047992"
  })));
};
export default SvgConditionIcon;